export default "__VITE_ASSET__Crr8Zgku__"